<template>
	<div class="progress">
		<h3 class="review-title">投稿进度查询</h3>
		<div class="step">
			<el-form :inline="true" :model="formInline" class="demo-form-inline">
			  <el-form-item label="投稿编号">
			    <el-input v-model="formInline.number" class="w350"></el-input>
			  </el-form-item>
			  <el-form-item label="作品名称">
			    <el-input v-model="formInline.name" class="w350"></el-input>
			  </el-form-item>
			  <el-form-item label="审核状态">
			    <el-select v-model="formInline.status" placeholder="审核状态" class="w350">
			      <el-option label="全部" value="0"></el-option>
			      <el-option label="初审已提交" value="1"></el-option>
			      <el-option label="初审中" value="2"></el-option>
			      <el-option label="初审已通过" value="3"></el-option>
			      <el-option label="复审已受理" value="4"></el-option>
			      <el-option label="复审中" value="5"></el-option>
			      <el-option label="复审已通过" value="6"></el-option>
			      <el-option label="未通过" value="7"></el-option>
			      <el-option label="已撤回" value="8"></el-option>
			    </el-select>
			  </el-form-item>
              <el-form-item label="投稿日期">
              	<el-date-picker v-model="formInline.dates" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="options"></el-date-picker>
              </el-form-item>
              <el-form-item label="结果排序方式">
			    <el-select v-model="formInline.sort" placeholder="结果排序方式" class="w350">
			      <el-option label="按创建时间降序" value="1"></el-option>
			      <el-option label="按创建时间升序" value="2"></el-option>
			    </el-select>
              </el-form-item>
			  <el-form-item>
			    <el-button type="primary" @click='demand' class="findBtn">查询</el-button>
			  </el-form-item>
			</el-form>
		</div>
        <div class="manage">
        	<p class="top">您有<span class="numb">{{totalNum}} </span>份投稿满足查询条件</p>
			 <el-table align='center'  :data="tableData"
			    style="width: 100%;margin: 0 auto;width: 970px;border-radius: 15px;margin-bottom: 20px;">
			    <el-table-column align='center'  label="投稿 编号"  width="250">
			      <template slot-scope="scope">
			        <span>{{ scope.row.num_order }}</span>
			      </template>
			    </el-table-column>
			    <el-table-column  label="作品名称"  width="230" align='center'>
			      <template slot-scope="scope">
			      	{{ scope.row.title }}
			      </template>
			    </el-table-column>
			    <el-table-column  label="投稿 /修改时间"  width="160" align='center'>
			      <template slot-scope="scope">
			        <span>{{ scope.row.created_at }}</span>
			      </template>
			    </el-table-column>
			    <el-table-column  label="审核状态"  width="170" align='center'  >
			      <template slot-scope="scope">
			        <span :style="{color:scope.row.color}" >{{ scope.row.statusNum }}</span>
			      </template>
			    </el-table-column>
			    <el-table-column label="操作" width="150" align='center'>
			      <template slot-scope="scope">
			        <el-button size="mini" type="primary" @click="lookDetail(scope.$index, scope.row)">查看详情</el-button>
			      </template>
			    </el-table-column>
			  </el-table>
			   <el-pagination  @size-change="handleSizeChange"  @current-change="handleCurrentChange"  :page-size="pageSize"  layout="prev, pager, next, jumper"  :total="total" style="text-align: center; margin-top: 35px;"></el-pagination>
	    </div>
        <div class="proce-info">所有投稿都可以在“个人中心-投稿管理”页面进行查看和管理：<span class="commitFirst" @click="manage">点击跳转</span></div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default{
		data(){
			return{
				tableData: [],
		        total:0,
		        status:'',
		        sort:'',
		        page:1,
		        pageSize:10,
		        totalNum:0,
		        formInline: {
		          number: '',
		          name:'',
		          status: '',
		          dates:'',
		          sort:''
		        },
		        options:{
		        	disabledDate(time){
					    return time.getTime() > Date.now();
					},
		        }
			}
		},
		methods:{
			manage(){
				axios({
					method:'post',
					url:process.env.BASE_URL + '/login/is-login',
					withCredentials:true,
				})
				.then(res =>{
					if(res.data.code == 10000){
						this.$router.push({path:'/person/manage'})
						this.$store.commit('SET_ISPERSON', false)
						this.$store.commit('SET_ISLOGIN', false)
						this.$store.commit('SET_ISCENTER', false)
						this.$store.commit('SET_ISFIRST', true)
					} else{
						this.$message(res.data.message)
					}
				})
				
			},
			createTable(status,sort,page,num_order,title,created_at){
				var form = new FormData
				form.append('status',status)
				form.append('sort',sort)
				form.append('page',page)
				form.append('pageSize',this.pageSize)

				form.append('num_order',num_order)
				form.append('title',title)
				form.append('created_at',created_at)
				axios({
					method:'post',
					url:process.env.BASE_URL+'/apply/lists',
					data:form,
					withCredentials:true
				})
				.then(res =>{
					if (res.data.code == 10000) {
						this.total = res.data.data.total
						this.tableData = res.data.data.rows
						this.totalNum = res.data.data.total
						var data = res.data.data.rows	
						for (var i = 0; i < data.length; i++) {						
							if(data[i].status == '1'){
								data[i].statusNum = '初审已提交'
								data[i].color = 'black'
								this.activeColor = data[i].color
							}
							if(data[i].status == '2'){
								data[i].statusNum = '初审中'
								data[i].color = '#D4AD25'
								this.activeColor = data[i].color
							}
							if(data[i].status == '3'){
								data[i].statusNum = '初审已通过'
								data[i].color = '#4DC55E'
								this.activeColor = data[i].color
							}
							if(data[i].status == '4'){
								data[i].statusNum = '复审已受理'
								data[i].color = '#A84FF4'
								this.activeColor = data[i].color
							}
							if(data[i].status == '5'){
								data[i].statusNum = '复审中'
								data[i].color = '#D4AD25'
								this.activeColor = data[i].color
							}
							if(data[i].status == '6'){
								data[i].statusNum = '复审已通过'
								data[i].color = '#4DC55E'
								this.activeColor = data[i].color
							}
							if(data[i].status == '7'){
								data[i].statusNum = '未通过'
								data[i].color = '#E13333'
								this.activeColor = data[i].color
							}
							if(data[i].status == '8'){
								data[i].statusNum = '已撤回'
								data[i].color = 'black'
								this.activeColor = data[i].color
							}
						}
					} else{
						this.$message({
				          message: res.data.message,
				          type: 'warning'
				        });
					}
				})
			},
			
			handleSizeChange(val) {
		        console.log(`每页 ${val} 条`);
		    },
		    handleCurrentChange(val) {
		       this.createTable(0,1,val,'','','')
		       this.page = val
		    },
			lookDetail(index,row){
				//查看详情
				 this.$router.push({ path: '/person/edit', query: { id: row.id }})
			},
			search(){				
			   if(this.status =='' && this.sort == ''){this.createTable(0,1,this.page)}
		       if (this.status != '' && this.sort == '') {this.createTable(this.status,1,this.page)}
		       if (this.status == '' && this.sort != '') {this.createTable(0,this.sort,this.page)}
		       if (this.status != '' && this.sort != '') { this.createTable(this.status,this.sort,this.page) }
			},
			demand(){	
				if(this.formInline.dates != ''){
					var findTime=this.formInline.dates[0] +' - '+ this.formInline.dates[1]
				}else{
					var findTime=''
				}
			   if(this.formInline.status == '' && this.formInline.sort == ''){
			   	 	this.createTable(0,1,this.page,this.formInline.number,this.formInline.name,findTime)
			   }else if(this.formInline.status != '' && this.formInline.sort == ''){
                    this.createTable(this.formInline.status,1,this.page,this.formInline.number,this.formInline.name,findTime)
			   }else if(this.formInline.status == '' && this.formInline.sort != ''){
                    this.createTable(0,this.formInline.sort,this.page,this.formInline.number,this.formInline.name,findTime)
			   }else if(this.formInline.status != '' && this.formInline.sort != ''){
                    this.createTable(this.formInline.status,this.formInline.sort,this.page,this.formInline.number,this.formInline.name,findTime)
			   }
		       	
			}
		},
		created(){
			this.createTable(0,1,1,'','','')
		}
	}
</script>

<style scoped>
.review-title{ font-size: 20px; font-weight: normal; text-align: center;  margin-bottom:35px;}
.step{ margin-bottom: -25px; }
.w350{ width: 350px; }
	.progress{
		width: 1000px;
		margin: 0 auto;
		padding-top: 270px;
		font-size: 26px;
	}
	.commitFirst{
		color: #409EFF; font-weight: bold; cursor: pointer;
	}
	.manage{
		 position: relative; padding:0 10px 20px; margin-top: 35px;
	}
	.roles{
		padding-top: 30px;
		font-size: 20px;
	}
	.color{
		color: #F6A68B;
	}
	.last{
		padding-bottom: 90px;
		display: inline-block;
	}
	.top{
		padding: 20px;
		padding-top: 25px; font-size: 16px;
	}
	.big{
		font-size: 22px;
	}
	.numb{
		color: red;
	}
	.search{
		position: absolute;
		top: 60px;
		right: 110px;
		width: 160px;
	}
	.search2{
		right: 280px;
	}
	.search3{
		right: 10px;
		width: 90px;
	}
	.proce-info{ font-size: 18px; text-align: center; padding:50px 0 80px; }
	.findBtn{ margin-left: 65px; }
</style>


// WEBPACK FOOTER //
// src/views/progress.vue